import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";

let list = [1, 2, 3, 4, 5]
let cards = [1, 2]


export const DashboardLoader = (props) => (

    <div className="container">
        <SkeletonTheme color="#f8f8f8" highlightColor="#FDFCFC">
            <div className="profile-block mx-auto align-center mb-10">
                <Skeleton circle={true} height={60} width={60} />
                <div className="dropdown profile-name-dropdown relative">
                    <Skeleton height={30} />
                </div>
            </div>
            <div className="payment-outstanding-history mx-auto">
                <div className="align-center mb-30">
                    <Skeleton width={100} height={40} />
                </div>

                <ul className="payment-tab mb-30 mt-20 d-inline-block w-100">
                    <li className={`pb-10  mr-20`}>OUTSTANDING</li>
                    <li className={`pb-10  px-10`}>HISTORY</li>
                </ul>
                <div className="payment-tab-content">
                    {list.map(item =>
                        (<div key={item} className="payment-item mb-15">
                            <div className="p-20 relative">
                                <Skeleton height={60} />
                            </div>
                        </div>))}
                </div>
            </div>
        </SkeletonTheme>
    </div>
)
export const InvoiceLoader = (props) => (

        <SkeletonTheme color="#f8f8f8" highlightColor="#FDFCFC">
            <div className="payment-tab-content">
                {list.map(item =>
                    (<div key={item} className="payment-item mb-15">
                        <div className="p-20 relative">
                            <Skeleton height={60} />
                        </div>
                    </div>))}
            </div>
        </SkeletonTheme>
)
export const CardsLoader = (props) => (

        <SkeletonTheme color="#f8f8f8" highlightColor="#FDFCFC">
            <div className="item row mb-15 shadow relative">
                {cards.map(item =>
                    <div className="p-10 form-select-card" key={item}>
                        <Skeleton height={80} />
                    </div>)
                }
            </div>
        </SkeletonTheme>
)